'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct6 from "./scala.-Product6.js";
var $p;
/** @constructor */
function $c_T6(_1, _2, _3, _4, _5, _6) {
  this.pS = null;
  this.pT = null;
  this.pU = null;
  this.pV = null;
  this.pW = null;
  this.pX = null;
  this.pS = _1;
  this.pT = _2;
  this.pU = _3;
  this.pV = _4;
  this.pW = _5;
  this.pX = _6;
}
export { $c_T6 as $c_T6 };
$p = $c_T6.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T6;
/** @constructor */
function $h_T6() {
}
export { $h_T6 as $h_T6 };
$h_T6.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 6;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct6.$f_s_Product6__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1037607828), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T6) && ((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pS, x$0.pS) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pT, x$0.pT)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pU, x$0.pU)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pV, x$0.pV)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pW, x$0.pW)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.pX, x$0.pX))));
});
$p.o = (function() {
  return "Tuple6";
});
$p.b = (function() {
  return (((((((((((("(" + this.pS) + ",") + this.pT) + ",") + this.pU) + ",") + this.pV) + ",") + this.pW) + ",") + this.pX) + ")");
});
function $isArrayOf_T6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eQ)));
}
export { $isArrayOf_T6 as $isArrayOf_T6 };
var $d_T6 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T6, "scala.Tuple6", ({
  eQ: 1,
  b: 1,
  c: 1,
  rZ: 1,
  a: 1
}));
export { $d_T6 as $d_T6 };
